<template>
  <div class="container">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacion" titulo="Afegir client" icono="fa-solid fa-plus" :loading="loading.creacion" @abrir="abrirModal('autofocusCreacion')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion" autocomplete="off" @submit.prevent="crear">
              <div class="form-group">
                <label for="nuevo-titol">Títol</label>
                <input ref="autofocusCreacion" type="text" class="form-control" id="nuevo-titol" v-model="nuevos.cliente.titol" :disabled="loading.creacion" maxlength="255" required />
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion" :disabled="loading.creacion"><i-submit icono="fa-plus" :loading="loading.creacion" />Confirmar</button>
          </template>
        </modal>
      </li>
      <li class="list-inline-item">
        <modal ref="modalTransferencia" titulo="Fusionar clients" icono="fa-solid fa-arrows-to-dot" :clases="['modal-lg']" :loading="loading.transferencia" @abrir="abrirModal('autofocusTransferencia')" @cerrar="cerrarTransferencia">
          <template v-slot:body>
            <form id="form-transferencia" autocomplete="off" @submit.prevent="transferir">
              <div class="alert alert-info" role="alert"><i class="fa-solid fa-triangle-exclamation"></i> S'eliminarà el client <b>Origen</b>, i es mantindrà el client <b>Destí</b> amb els projectes de tots dos.</div>
              <div class="row">
                <div class="col d-flex align-items-center justify-content-around">
                  <label for="transferencia-proyecto-origen">Origen</label>
                  <i class="fa-solid fa-arrow-right-arrow-left" role="button" tabindex="0" @click="intercambiar"></i>
                  <label for="transferencia-proyecto-destino">Destí</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <select class="form-control" id="transferencia-cliente-origen" v-model="nuevos.transferencia.origen" :disabled="loading.transferencia" required>
                      <option v-for="(cliente, index) in transferenciaRows" :key="index" :value="cliente.id" :disabled="nuevos.transferencia.destino == cliente.id">{{ cliente.titol }}</option>
                    </select>
                  </div>
                  <dl v-if="transferenciaOrigen" class="text-center text-muted">
                    <dt>Estat</dt>
                    <dd v-html="transferenciaOrigen.es_actiu ? 'Actiu' : 'Inactiu'"></dd>
                  </dl>
                </div>
                <div class="col">
                  <div class="form-group">
                    <select class="form-control" id="transferencia-cliente-destino" v-model="nuevos.transferencia.destino" :disabled="loading.transferencia" required>
                      <option v-for="(cliente, index) in transferenciaRows" :key="index" :value="cliente.id" :disabled="nuevos.transferencia.origen == cliente.id">{{ cliente.titol }}</option>
                    </select>
                  </div>
                  <dl v-if="transferenciaDestino" class="text-center text-muted">
                    <dt>Estat</dt>
                    <dd v-html="transferenciaDestino.es_actiu ? 'Actiu' : 'Inactiu'"></dd>
                  </dl>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-transferencia" :disabled="loading.transferencia"><i-submit icono="fa-share-from-square" :loading="loading.transferencia" />Confirmar</button>
          </template>
        </modal>
      </li>
    </ul>
    <vue-bootstrap4-table ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap client</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar client" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar client" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar client" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="custom-control custom-switch mb-3">
                  <input type="checkbox" class="custom-control-input" :id="`actiu${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).es_actiu" :disabled="loading.edicion" />
                  <label class="custom-control-label" :for="`actiu${props.row.id}`">Actiu</label>
                </div>
                <div class="form-group">
                  <label :for="`titol${props.row.id}`">Títol</label>
                  <input :ref="`autofocusEdicion${props.row.id}`" type="text" class="form-control" :id="`titol${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).titol" :disabled="loading.edicion" maxlength="255" required />
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`"><i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar</button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar client" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar <b>{{ props.row.titol }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="es_actiu" slot-scope="props">
        <i v-show="props.cell_value" class="fa-solid fa-circle-check"></i>
      </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss"></style>

<script>
export default {
  name: "Clients",
  inject: ["exportarTabla", "exportarBolcat", "actionsExportar"],
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
        transferencia: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Actiu",
          name: "es_actiu",
          filter: {
            type: "select",
            mode: "single",
            closeDropdownOnSelection: true,
            placeholder: "Filtra estat",
            options: [
              {
                name: "Actiu",
                value: 1,
              },
              {
                name: "Inactiu",
                value: 0,
              },
            ],
          },
          sort: false,
          row_text_alignment: "text-center",
          slot_name: "es_actiu",
        },
        {
          label: "Títol",
          name: "titol",
          filter: {
            type: "simple",
            placeholder: "Filtra títol",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Tots els clients",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        cliente: {
          titol: null,
        },
        transferencia: {
          origen: null,
          destino: null,
        },
      },
    };
  },
  computed: {
    transferenciaOrigen() {
      return this.getRowId(this.nuevos.transferencia.origen, this.rows);
    },
    transferenciaDestino() {
      return this.getRowId(this.nuevos.transferencia.destino, this.rows);
    },
    transferenciaRows() {
      return Array.from(this.rows).sort((a, b) => (a.titol.toLowerCase() > b.titol.toLowerCase() ? 1 : -1));
    },
  },
  methods: {
    getData: function () {
      this.$http.get("api/clients").then((response) => {
        this.rows = response.data;
      });
    },
    getRowId: function (id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    crear: function () {
      this.loading.creacion = true;

      this.$http
        .post("api/clients", this.nuevos.cliente)
        .then((response) => {
          this.loading.creacion = false;

          this.$nextTick(function () {
            if (response.status == 201) {
              this.rows.push(response.data);

              this.$refs.modalCreacion.cerrar();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Client afegit correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacion = false;
        });
    },
    editar: function (id) {
      this.loading.edicion = true;

      this.$http
        .patch(`api/clients/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(function () {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();

              this.rows = structuredClone(this.rowsBuffer);

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Client editat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/clients/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Client eliminat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    cerrarCreacion: function () {
      this.nuevos.cliente.titol = null;
    },
    cerrarEdicion: function () {
      this.rowsBuffer = structuredClone(this.rows);
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    transferir: function () {
      this.loading.transferencia = true;

      this.$http
        .delete(`api/clients/${this.nuevos.transferencia.origen}?${new URLSearchParams({ destino: this.nuevos.transferencia.destino })}`)
        .then((response) => {
          this.$nextTick(function () {
            this.$refs[`modalTransferencia`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == this.nuevos.transferencia.origen);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Fusió realitzada correctament.` });
            }
          });
        })
        .catch((error) => { })
        .finally(() => (this.loading.transferencia = false));
    },
    intercambiar: function () {
      const origen = this.nuevos.transferencia.origen;
      const destino = this.nuevos.transferencia.destino;

      this.$set(this.nuevos.transferencia, "origen", destino);
      this.$set(this.nuevos.transferencia, "destino", origen);
    },
    cerrarTransferencia: function () {
      this.nuevos.transferencia.origen = null;
      this.nuevos.transferencia.destino = null;

      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>